import { useEffect, useState } from "react";
import AdsterraBanner from "./AdsterraBanner";
import "./CornerAds.css";

const SKYSCRAPER_KEY = "8d1148c1970b669836e5de08e623e74b";
const DISMISS_KEY = "epsviewer_corner_ads_dismissed";
// The box needs ~184px (160 wide + 12px left offset + box padding). When
// visible, body.has-left-ad reserves 200px (CornerAds.css) so the gutter
// covers the box with a small gap to spare — keep that value in sync here.
const MIN_WIDTH = 1100;
// Box sits below the header now (68px header + 12px gap + ~624px box + a
// buffer) instead of pinned to the bottom, so it needs more headroom than
// before to avoid clipping at the bottom of shorter viewports.
const MIN_HEIGHT = 740;
const BODY_CLASS = "has-left-ad";

function fits() {
  return (
    typeof window !== "undefined" &&
    window.innerWidth >= MIN_WIDTH &&
    window.innerHeight >= MIN_HEIGHT
  );
}

// Left side only for now — right rail is disabled until told otherwise.
export default function CornerAds() {
  const [visible, setVisible] = useState(fits);
  const [dismissed, setDismissed] = useState(
    () => typeof window !== "undefined" && sessionStorage.getItem(DISMISS_KEY) === "1"
  );

  useEffect(() => {
    const onResize = () => setVisible(fits());
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const showing = visible && !dismissed;

  // Reserve a left gutter site-wide (header/main/footer all shift via the
  // body margin) whenever the ad is actually on screen, so it never sits on
  // top of page content instead of just floating over it.
  useEffect(() => {
    document.body.classList.toggle(BODY_CLASS, showing);
    return () => document.body.classList.remove(BODY_CLASS);
  }, [showing]);

  if (!showing) return null;

  const dismiss = () => {
    sessionStorage.setItem(DISMISS_KEY, "1");
    setDismissed(true);
  };

  return (
    <div className="corner-ad corner-ad--left">
      <button type="button" className="corner-ad__close" aria-label="Close advertisement" onClick={dismiss}>
        ×
      </button>
      <span className="corner-ad__label">Ad</span>
      <AdsterraBanner adKey={SKYSCRAPER_KEY} width={160} height={600} />
    </div>
  );
}
